<div class="page-header-container left-wrapper flex-utility align-center">

  <div *ngIf="filtersCounter === 0" class="filters-label">{{ 'PAGES.FILTER.TITLE' | translate }}:&nbsp;</div>
  <div *ngIf="filtersCounter > 0" class="filters-label">{{ 'PAGES.FILTER.TITLE-1' | translate:{n: filtersCounter} }}:
  </div>
  <form #formRef class="row" [class.expanded]="showMoreFilters" (keyup.enter)="apply()">

    <!-- FILTRO PER COUNTRIES -->
    <mat-form-field class="showcase-select-field">
      <mat-select [placeholder]="'PAGES.FILTER.PLACEHOLDERS.SEARCH_COUNTRY' | translate"
        [formControl]="countriesFormControl" multiple>
        <mat-select-trigger>
          <mat-chip-list>
            <mat-chip *ngFor="let country of countriesFormControl.value" [removable]="true"
              (removed)="removeChip(COUNTRIES, country)">
              {{ country }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </mat-select-trigger>
        <mat-option *ngFor="let country of countries" [value]="country.name">
          <p class="text-value"> {{ country.name }} </p>
        </mat-option>
      </mat-select>
    </mat-form-field>


    <!-- FILTRO PER EVENT_TYPE -->
    <mat-form-field class="showcase-select-field">
      <mat-select [formControl]="eventTypeFormControl"
        [placeholder]="'PAGES.FILTER.PLACEHOLDERS.SEARCH_EVENT_TYPE' | translate">
        <mat-option *ngFor="let opt of EVENT_TYPE_OPTIONS" [value]="opt.value">
          <p class="text-value"> {{opt.key | translate}} </p>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- FILTRO PER SALES ROOMS -->
    <mat-form-field class="showcase-select-field">
      <mat-select [placeholder]="'PAGES.FILTER.PLACEHOLDERS.SEARCH_SALES_ROOMS' | translate"
        [formControl]="salesRoomsControl" multiple>
        <mat-select-trigger>
          <mat-chip-list>
            <mat-chip *ngFor="let sr of salesRoomsControl.value" [removable]="true"
              (removed)="removeChip(SALES_ROOM,sr)">
              {{ sr.value}}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </mat-select-trigger>
        <mat-option *ngFor="let sr of parsedSalesRooms" [value]="sr">
          <p class="text-value"> {{ sr.value }} </p>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- FILTRO PER CLIENT_ADVISOR -->
    <app-search-select [defaultValue]="getValueSelect(CLIENT_ADVISOR)" [controlledInputValue]="selectedClientAdvisorId"
      [hintText]="'PAGES.FILTER.PLACEHOLDERS.SEARCH_CLIENT_ADVISOR' | translate" [keyId]="CLIENT_ADVISOR"
      [noBorder]="true" (hasSelectOption)="optionSelected($event, CLIENT_ADVISOR)">
    </app-search-select>

    <!-- FILTRO PER ASSISTANT -->
    <app-search-select [defaultValue]="getValueSelect(ASSISTANT)" [controlledInputValue]="selectedAssistantId"
      [hintText]="'PAGES.FILTER.PLACEHOLDERS.SEARCH_ASSISTANT' | translate" [keyId]="ASSISTANT" [noBorder]="true"
      (hasSelectOption)="optionSelected($event, ASSISTANT)">
    </app-search-select>

    <!-- FILTRO PER RUNNER -->
    <app-search-select [defaultValue]="getValueSelect(RUNNER)" [controlledInputValue]="selectedRunnerId"
      [hintText]="'PAGES.FILTER.PLACEHOLDERS.SEARCH_RUNNER' | translate" [keyId]="RUNNER" [noBorder]="true"
      (hasSelectOption)="optionSelected($event, RUNNER)">
    </app-search-select>

    <!-- FILTRO PER STATUSES -->
    <mat-form-field class="showcase-select-field">
      <mat-select [placeholder]="'PAGES.FILTER.PLACEHOLDERS.SEARCH_APPOINTMENT_STATUS' | translate"
        [formControl]="statusesFormControl" multiple>
        <mat-select-trigger>
          <mat-chip-list>
            <mat-chip *ngFor="let status of statusesFormControl.value" [removable]="true"
              (removed)="removeChip(STATUSES, status)">
              {{ sharedService.translateAppointmentStatus(+status) }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </mat-select-trigger>
        <mat-option *ngFor="let status of appointmentStatus" [value]="status.toString()">
          <p class="text-value"> {{ sharedService.translateAppointmentStatus(status) }} </p>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- FILTRO PER STATO WELCOME -->
    <mat-form-field class="select-field">
      <mat-select [placeholder]="'PAGES.FILTER.HASCHECKINDATE.3' | translate" [formControl]="hasCheckInDateFormControl">
        <mat-option [value]="null">
          <p class="text-value"> {{"PAGES.FILTER.HASCHECKINDATE.0" | translate}} </p>
        </mat-option>
        <mat-option [value]="true">
          <p class="text-value"> {{"PAGES.FILTER.HASCHECKINDATE.1" | translate}} </p>
        </mat-option>
        <mat-option [value]="false">
          <p class="text-value"> {{"PAGES.FILTER.HASCHECKINDATE.2" | translate}} </p>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- FILTRO PER SEARCH_START_TIME -->
    <mat-form-field class="showcase-select-field input-time">
      <mat-select [formControl]="slotStartControl" [placeholder]="'PAGES.FILTER.PLACEHOLDERS.ALL_SLOTS' | translate">
        <mat-option *ngFor="let opt of hoursOptions" [value]="opt.value">
          <p class="text-value"> {{opt.label}} </p>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- FILTRO PER SEARCH_END_TIME -->
    <mat-form-field class="showcase-select-field input-time">
      <mat-select [formControl]="slotEndControl" [placeholder]="'PAGES.FILTER.PLACEHOLDERS.ALL_SLOTS' | translate">
        <mat-option *ngFor="let opt of hoursOptions" [value]="opt.value">
          <p class="text-value"> {{opt.label}} </p>
        </mat-option>
      </mat-select>
    </mat-form-field>

  </form>
  <div class="button-wrapper">
    <ng-container *ngIf="showMoreAndLessButtons">
      <app-bulgari-button *ngIf="showMoreFilters" [type]="'flat'" (click)="showFilters(false)"
        [customStyle]="'text-transform: capitalize;'" [text]="'PAGES.FILTER.SHOW_LESS'"></app-bulgari-button>
      <app-bulgari-button *ngIf="!showMoreFilters" [type]="'flat'" (click)="showFilters(true)"
        [customStyle]="'text-transform: capitalize;'" [text]="'PAGES.FILTER.SHOW_MORE'"></app-bulgari-button>
    </ng-container>
    <app-bulgari-button [type]="'primary'" (click)="apply()" [customStyle]="'text-transform: capitalize;'"
      [text]="'PAGES.FILTER.APPLY'"></app-bulgari-button>
    <app-bulgari-button [type]="'flat'" (click)="reset()"
      [customStyle]="'background: transparent; border: none; text-decoration: underline; text-transform: uppercase;'"
      [text]="'PAGES.FILTER.RESET_FILTER'"></app-bulgari-button>
  </div>
</div>
